<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column class="key" field="key" label="Key" sortable>
            {{props.row.key|toLabel}}
          </b-table-column>
          <b-table-column field="subject" label="Subject" sortable>
            {{props.row.subject}}
          </b-table-column>
          <b-table-column field="body" label="Body" sortable>
            {{props.row.body|truncate}}
          </b-table-column>
          <b-table-column field="charcount" label="Characters" sortable>
            {{props.row.body|chars}}
          </b-table-column>
          <b-table-column field="_id" label="Edit">
            <span class="edit" v-on:click="showMessage(props.row._id)"><b-icon icon="square-edit-outline" /></span>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <MessageDetail v-if="showDetail" :message="message" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getMessages } from "../api/methods";
import { messageSchema } from "../store/schemas";
import filters from "../mixins/filters";
import MessageDetail from "./MessageDetail";
import { mailingCategories, coreMailKeys } from "../api/mailing-categories";
import { bus } from "../main";

export default {
  name: 'MessageList',
  components: {
    MessageDetail
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      showDetail: false,
      currId: '',
      message: {
        type: Object,
        default() {
          return messageSchema;
        }
      },
      categoryKeys: coreMailKeys
    }
  },
  computed: {
    ...mapGetters(["messages"]),
    wrapperClasses() {
      let cls = ["messages"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    numItems() {
      return this.messages.length;
    },
  },
  mounted() {
    if (this.$route.path) {
      const parts = this.$route.path.substring(1).split('/');
      if (parts.length > 1) {
        this.currId = parts[1];
      }
      this.categoryKeys = [...coreMailKeys, ...mailingCategories.map(cat => cat.mailKey)];
      
    }
    setTimeout(() => {
      this.mapMessages();
    }, 500);
    bus.$on('message-updated', (message) => {
      if (message instanceof Object) {
        const { _id } = message;
        if (_id) {
          const strId = _id.toString();
          const index = this.items.findIndex(s => s._id.toString() === strId);
          if (index >= 0) {
            this.items.splice(index, 1, message);
          }
        }
      }
    });
  },
  filters: {
    namePart(val) {
      const parts = val.split('__');
      parts.shift();
      const name = parts.join(" ").replace(/_+/g, " ");
      return name;
    },
  },
  methods: {
    mapMessages(remap) {
      if (this.items.length < 1 || remap === true) {
        getMessages().then(data => {
          if (data.items instanceof Array) {
            this.items = data.items.filter(mail => this.categoryKeys.includes(mail.key));
            if (this.currId) {
              if (this.currId.length > 3) {
                this.showMessage(this.currId);
              }
            }
          }
        });
      }
    },
    remapMessages() {
      this.mapMessages(true);
    },
    showMessage(id) {
      const message = this.items.find(s => s._id === id);
      if (message instanceof Object) {
        if (message.key) {
          this.message = message;
          const newPath = '/messages/' + id;
          if (this.$route.path !== newPath) {
            this.$router.push(newPath);
          }
          this.showDetail = true;
          this.currId = id;
        }
      }
    },
    close() {
      this.showDetail = false;
      this.$router.push('/messages/' + this.sectionFilter);
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
  }
}
</script>